module.exports = __webpack_public_path__ + "assets/figma.476ecce8.svg";